module.exports = __webpack_public_path__ + "media/images/photo/plans/places/kyu_guggenheim_tei-184fa4d6b09bf4153b6fad04fe1653c9.png";